import { Button, Col, Form, Row, Select } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ECapReportStepProps } from ".";
import { VALIDATION_MESSAGE_CONFIG } from "../../../../constants/constants";
import AmountInput from "../../../atoms/amount-input";


const BRInput = (props: ECapReportStepProps) => {

    const { t } = useTranslation();
    const [form] = Form.useForm();

    const formSubmit = (values: any) => {

        if (props.next) {
            props.next(values);
        }
    }

    useEffect(() => {
        if (props.resources?.target_ratings && props.resources?.target_ratings.length) {
            form.setFieldsValue({ target_rating: props.resources?.target_ratings[0] });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.resources?.target_ratings])

    const renderYears = () => {
        const yearControls = [];
        for (let index = 1; index <= 5; index++) {
            const yearControl = <Form.Item
                key={index}
                label={null}
            >
                <Row gutter={12} className="flex-1" >
                    <Col span={6} style={{ display: 'inline-flex', alignItems: 'center' }} className="center year-center">
                        <label className="fw-medium">{`${t("EcapModule.lbYear")} ${index}:`}</label>
                    </Col>

                    <Col span={18}>
                        <Form.Item
                            rules={[
                                { required: true, message: "" }
                            ]}
                            name={`year${index}`}
                        >
                            <AmountInput placeholder={t("EcapModule.plValue")} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form.Item>
            yearControls.push(yearControl);
        }

        return yearControls;
    }

    return (
        <div className="step-content-item-wrapper">

            <div className="step-content-item-header">
                <h4>
                    {t("EcapModule.lbTitleInput")}
                </h4>
            </div>

            <Form
                layout='vertical'
                validateMessages={VALIDATION_MESSAGE_CONFIG}
                onFinish={(values) => formSubmit(values)}
                form={form}
                scrollToFirstError>

                <Form.Item
                    label={t("EcapModule.lbDesiredRatingLevel")}
                    name="target_rating">
                    <Select>
                        {
                            props.resources?.target_ratings && props.resources?.target_ratings?.map((item, index) => (
                                <Select.Option value={item} key={index}>
                                    {
                                        item
                                    }
                                </Select.Option>
                            ))
                        }
                    </Select>

                </Form.Item>

                <div className="or-form-list">
                        {renderYears()}
                </div>

                <Row gutter={8}>
                    <Col span={12}>
                        <Button type="default" onClick={props.goback} block shape="round">
                            {t("Onboarding.btnGoback")}
                        </Button>
                    </Col>
                    <Col span={12}>
                        <Button htmlType="submit" type="primary" shape="round" block>
                            {
                                t("RapmReport.btnNext")
                            }
                        </Button>
                    </Col>
                </Row>


            </Form>

        </div>
    )
}

export default BRInput;